import { NextPage } from 'next'
import React from 'react'
import { LinkRedirect } from 'src/components/pages/link_redirect'

const Page: NextPage = () => {
  return (
    <>
      <LinkRedirect />
    </>
  )
}

export default Page
